import Http from "../../http/client";

export default async (userId) => {
  const response = await Http.get('admin/card', {
    params: {
      userId
    }
  });
  return response.data;
}
